export * from "./TriviaLarge";
